// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3pu7f","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2SX6B","obliqueLine":"membershipbadge_obliqueLine__1XcIX"};